"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripComments = void 0;
const core_1 = require("../core");
const helpers_1 = require("../helpers");
const isDelimiter = () => false;
const shouldAddToken = (type) => !helpers_1.isComment(type);
function stripComments(source, parseLineComments = true) {
    const tokens = core_1.tokenize(source, {
        isDelimiter,
        isStringDelimiter: helpers_1.isStringDelimiter,
        isWhitespace: helpers_1.isWhitespace,
        shouldAddToken,
        createToken: helpers_1.createToken,
        getCommentStartType: parseLineComments
            ? helpers_1.getJSCommentStartType
            : helpers_1.getMultilineCommentStartType,
        isCommentEnd: helpers_1.isCommentEnd,
        getUnclosedComment: helpers_1.getUnclosedComment,
    });
    return helpers_1.getText(tokens);
}
exports.stripComments = stripComments;
//# sourceMappingURL=strips-comments.js.map